module.exports = __webpack_public_path__ + "img/Oracle_island.4db960ca.png";